<template>
  <svg class="svg-icon" aria-hidden="true">
    <use :xlink:href="symbolId" rel="external icon" />
  </svg>
</template>

<script>
import { defineComponent, computed } from 'vue';
export default defineComponent({
  name: 'SvgIcon',
  props: {
    name: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const symbolId = computed(() => `#icon-${props.name}`);
    return {
      symbolId
    };
  }
});
</script>